module.exports = __webpack_public_path__ + "static/img/5792_phase_function_Paper_Points.4f167ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5792_phase_function_Paper_Points.png
// module id = RY8K
// module chunks = 0